import { PagingDto } from "src/api/models/v1/dto/common/pagingDto";

export const InitialPaging: PagingDto = {
	pageNumber: 1,
	pageSize: 10,
	pageCount: 0,
	recordCount: 0,
};
